export const defaultFilters = () => ({
  query: '',
  type: null as string | null,
});
